import { createRouter, createWebHistory } from "vue-router";
import Auth from "../views/EmcAuth.vue";
import { getUser, sessionCheck, sessionEndLogout } from "@/router/utils";

const RdmUsers = () => import("../views/RdmUsers.vue");
const RdmMenuLeft = () => import("../components/rdm/nav/RdmMenuLeft.vue");
const RdmUsersList = () => import("../components/rdm/RdmUsersList.vue");
const RdmAddUser = () => import("../components/rdm/RdmAddUser.vue");
const RdmEditUser = () => import("../components/rdm/RdmEditUser.vue");
const RdmEditUserShips = () => import("../components/rdm/RdmEditUserShips.vue");

const EmcConsole = () => import("../views/EmcConsole.vue");
const EmcConsoleMenuLeft = () =>
  import("../components/emcConsole/nav/EmcConsoleMenuLeft.vue");
const EmcUsersList = () => import("../components/emcConsole/EmcUsersList.vue");
const EmcAddUser = () => import("../components/emcConsole/EmcAddUser.vue");
const EmcEditUser = () => import("../components/emcConsole/EmcEditUser.vue");
const EmcLogView = () => import("../components/emcConsole/EmcLogView.vue");

const Kpi = () => import("../views/EmcKpi.vue");
const KpiMenuLeft = () => import("../components/kpi/nav/KpiMenuLeft.vue");
const KpiDashboard = () => import("../components/kpi/KpiDashboard.vue");
const KpiDetails = () => import("../components/kpi/KpiDetails.vue");
const ImporterKpi = () => import("../components/kpi/ImporterKpi.vue");
const WatchdogShipKpi = () => import("../components/kpi/WatchdogShipKpi.vue");
const DataVerificationShipKpi = () =>
  import("../components/kpi/DataVerificationShipKpi.vue");

const Ship = () => import("../views/EmcShip.vue");
const ShipMenuLeft = () => import("../components/ship/nav/ShipMenuLeft.vue");
const ShipList = () => import("../components/ship/ShipList.vue");
const ShipProfile = () => import("../components/ship/ShipProfile.vue");

const Tickets = () => import("../views/Tickets.vue");
const TicketsMenuLeft = () =>
  import("../components/tickets/nav/TicketsMenuLeft.vue");
const TicketsList = () => import("../components/tickets/TicketsList.vue");
const TicketsClosedList = () =>
  import("../components/tickets/TicketsClosedList.vue");
const TicketsCustomList = () =>
  import("../components/tickets/TicketsCustomList.vue");

const Activation = () => import("../views/Activation.vue");
const ActivationMenuLeft = () =>
  import("../components/activation/nav/ActivationMenuLeft.vue");
const EmailsTable = () => import("../components/activation/EmailsList.vue");
const DeletedEmailsTable = () =>
  import("../components/activation/DeletedEmailsList.vue");
const EmailsListFilters = () =>
  import("../components/activation/EmailsListFilters.vue");

const ApiUsers = () => import("../views/ApiUsers.vue");
const ApiUsersMenuLeft = () => import("../components/api/nav/ApiMenuLeft.vue");
const ApiUsersTable = () => import("../components/tables/ApiUsersTable.vue");
const UserPermissionsData = () =>
  import("../components/permissions/UserPermissionsData.vue");

const EvtApiLicence = () => import("../views/EvtApiLicence.vue");
const EvtApiLicenceMenuLeft = () =>
  import("../components/evtApiLicence/nav/EvtApiLicenceMenuLeft.vue");
const EvtUsersList = () =>
  import("../components/evtApiLicence/EvtUsersList.vue");
const EvtAddUser = () => import("../components/evtApiLicence/EvtAddUser.vue");

const Delivery = () => import("../views/Delivery.vue");
const DeliveryMenuLeft = () =>
  import("../components/delivery/nav/DeliveryMenuLeft.vue");
const DeliveryList = () => import("../components/delivery/ListPage.vue");

const Service = () => import("../views/Service.vue");
const ServiceMenuLeft = () =>
  import("../components/service/nav/ServiceMenuLeft.vue");
const ServiceList = () =>
  import("../components/service/ServiceMainContent.vue");
const ServiceCasesList = () =>
  import("../components/service/CasesListPage.vue");
const SlaLicensesList = () =>
  import("../components/service/SlaLicensesListPage.vue");
const SystemList = () => import("../components/service/SystemList.vue");
const AnnualReportsList = () =>
  import("../components/service/AnnualReportsList.vue");
const AnnualReportsMenuLeft = () =>
  import("../components/service/nav/AnnualReportsMenuLeft.vue");

// Test only
const TestTab = () => import("../views/TestTab.vue");
const TestTabMenuLeft = () => import("../components/test/nav/TestMenuLeft.vue");
const TestTabHeatMapChart = () => import("../components/test/TestPage.vue");

const routes = [
  { path: "/:pathMatch(.*)*", component: Auth },
  {
    path: "/login",
    alias: "/",
    name: "login",
    component: Auth,
  },
  {
    path: "/rdmUsers",
    name: "RdmUsers",
    component: RdmUsers,
    children: [
      {
        path: "/rdmUsers/listUsers",
        components: {
          default: RdmUsersList,
          menuLeft: RdmMenuLeft,
        },
      },
      {
        path: "/rdmUsers/addUser",
        components: {
          default: RdmAddUser,
          menuLeft: RdmMenuLeft,
        },
      },
      {
        path: `/rdmUsers/editUserForm`,
        components: {
          default: RdmEditUser,
          menuLeft: RdmMenuLeft,
        },
        props: {
          default: (route) => ({ query: route.query.id }),
        },
      },
      {
        path: `/rdmUsers/editUserShipsForm`,
        components: {
          default: RdmEditUserShips,
          menuLeft: RdmMenuLeft,
        },
        props: {
          default: (route) => ({ query: route.query.id }),
        },
      },
    ],
  },
  {
    path: "/emcConsole",
    name: "EMCConsole",
    component: EmcConsole,
    children: [
      {
        path: "/emcConsole/listUsers",
        components: {
          default: EmcUsersList,
          menuLeft: EmcConsoleMenuLeft,
        },
      },
      {
        path: "/emcConsole/addUser",
        components: {
          default: EmcAddUser,
          menuLeft: EmcConsoleMenuLeft,
        },
        props: {
          default: true,
        },
      },
      {
        path: "/emcConsole/logView",
        name: "emcLogView",
        components: {
          default: EmcLogView,
          menuLeft: EmcConsoleMenuLeft,
        },
      },
      {
        path: `/emcConsole/editUserForm`,
        component: EmcEditUser,
        components: {
          default: EmcEditUser,
          menuLeft: EmcConsoleMenuLeft,
        },
        props: {
          default: (route) => ({ query: route.query.id }),
        },
      },
    ],
  },
  {
    path: "/ship",
    name: "Ship",
    component: Ship,
    children: [
      {
        path: "/ship/listShips",
        components: {
          default: ShipList,
          menuLeft: ShipMenuLeft,
        },
      },
      {
        name: "shipProfile",
        path: "/ship/profile/:maintainer/:ship_id",
        components: {
          default: ShipProfile,
          menuLeft: ShipMenuLeft,
        },
        props: {
          default: true,
        },
      },
    ],
  },
  {
    path: "/evtApiLicence",
    name: "EVTApiLicence",
    component: EvtApiLicence,
    children: [
      {
        path: "/evtApiLicence/listUsers",
        components: {
          default: EvtUsersList,
          menuLeft: EvtApiLicenceMenuLeft,
        },
      },
      {
        path: "/evtApiLicence/addUser",
        components: {
          default: EvtAddUser,
          menuLeft: EvtApiLicenceMenuLeft,
        },
      },
    ],
  },
  {
    path: "/kpi",
    name: "Kpi",
    component: Kpi,
    children: [
      {
        name: "kpiDashboard",
        path: "/kpi/kpiDashboard",
        components: {
          default: KpiDashboard,
          menuLeft: KpiMenuLeft,
        },
      },
      {
        path: "/kpi/importerKpi",
        components: {
          default: ImporterKpi,
          menuLeft: KpiMenuLeft,
        },
      },
      {
        name: "KpiDetails",
        path: "/kpi/kpiDetails",
        components: {
          default: KpiDetails,
          menuLeft: KpiMenuLeft,
        },
      },
      {
        name: "watchdogShipKpi",
        path: "/kpi/watchdogShipKpi",
        components: {
          default: WatchdogShipKpi,
          menuLeft: KpiMenuLeft,
        },
        props: {
          default: true,
        },
      },
      {
        name: "dataVerificationShipKpi",
        path: "/kpi/dataVerificationShipKpi",
        components: {
          default: DataVerificationShipKpi,
          menuLeft: KpiMenuLeft,
        },
        props: {
          default: true,
        },
      },
    ],
  },
  {
    path: "/tickets",
    name: "Tickets",
    component: Tickets,
    children: [
      {
        name: "ticketsList",
        path: "/tickets/listTickets",
        components: {
          default: TicketsList,
          menuLeft: TicketsMenuLeft,
        },
      },
      {
        name: "ticketsClosedList",
        path: "/tickets/listClosedTickets",
        components: {
          default: TicketsClosedList,
          menuLeft: TicketsMenuLeft,
        },
      },
      {
        name: "ticketsCustomList",
        path: "/tickets/listCustomTickets",
        components: {
          default: TicketsCustomList,
          menuLeft: TicketsMenuLeft,
        },
      },
    ],
  },
  {
    path: "/activationTime",
    name: "DataEmails",
    component: Activation,
    children: [
      {
        name: "emailsList",
        path: "/activationTime/listEmails",
        components: {
          default: EmailsTable,
          menuLeft: ActivationMenuLeft,
        },
      },
      {
        name: "deletedEmailsList",
        path: "/activationTime/listDeletedEmails",
        components: {
          default: DeletedEmailsTable,
          menuLeft: ActivationMenuLeft,
        },
      },
      {
        name: "emailsListFilters",
        path: "/activationTime/emailsListFilters",
        components: {
          default: EmailsListFilters,
          menuLeft: ActivationMenuLeft,
        },
      },
    ],
  },
  {
    path: "/apiUsers",
    name: "apiUsers",
    component: ApiUsers,
    children: [
      {
        name: "/apiUsersList",
        path: "/apiUsers/apiUsersList",
        components: {
          default: ApiUsersTable,
          menuLeft: ApiUsersMenuLeft,
        },
      },
      {
        name: "UserPermissionsData",
        path: "/apiUsers/permissions",
        components: {
          default: UserPermissionsData,
          menuLeft: ApiUsersMenuLeft,
        },
      },
    ],
  },
  {
    path: "/deliveryTime",
    name: "SparesDeliveryTime",
    component: Delivery,
    children: [
      {
        name: "deliveryTimeList",
        path: "/deliveryTime/list",
        components: {
          default: DeliveryList,
          menuLeft: DeliveryMenuLeft,
        },
      },
    ],
  },
  {
    path: "/service",
    name: "Service",
    component: Service,
    children: [
      {
        name: "ServiceList",
        path: "/service/list",
        components: {
          default: ServiceList,
          menuLeft: ServiceMenuLeft,
        },
      },
      {
        name: "ServiceCases",
        path: "/service/cases",
        components: {
          default: ServiceCasesList,
          menuLeft: ServiceMenuLeft,
        },
      },
      {
        name: "SlaLicencesList",
        path: "/service/sla",
        components: {
          default: SlaLicensesList,
          menuLeft: ServiceMenuLeft,
        },
      },
      {
        name: "SystemList",
        path: "/service/system",
        components: {
          default: SystemList,
          menuLeft: ServiceMenuLeft,
        },
        props: {
          default: {
            showFilter: true,
          },
        },
      },
      {
        name: "AnnualReportsList",
        path: "/service/annual-reports",
        components: {
          default: AnnualReportsList,
          menuLeft: AnnualReportsMenuLeft,
        },
      },
    ],
  },
  {
    path: "/testTab",
    name: "testTab",
    component: TestTab,
    children: [
      {
        name: "TestPage",
        path: "/testTab/testPage",
        components: {
          default: TestTabHeatMapChart,
          menuLeft: TestTabMenuLeft,
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const loggedIn = getUser();

  if (loggedIn != null) {
    let session = await sessionCheck(loggedIn);
    await sessionEndLogout(session, next);
  }

  if ((to.name !== "login" && !loggedIn) || (to.name === "" && !loggedIn))
    next({ name: "login" });
  else next();
});

export default router;
